import React from "react";

const ImportSettingIcon = ({ className = "", width = 64, height = 64, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M17.8281 32.154C17.8281 25.7517 23.0182 20.5616 29.4205 20.5616H50.5893C56.9916 20.5616 62.1817 25.7517 62.1817 32.154C62.1817 38.5563 56.9916 43.7464 50.5893 43.7464H29.4205C23.0182 43.7464 17.8281 38.5563 17.8281 32.154Z"
        fill="#B3B4B6"
      />

      <path
        d="M55.1317 23.9411C55.1317 32.2919 48.362 39.0616 40.0112 39.0616C31.6603 39.0616 24.8906 32.2919 24.8906 23.9411C24.8906 15.5902 31.6603 8.82051 40.0112 8.82051C48.362 8.82051 55.1317 15.5902 55.1317 23.9411Z"
        fill="#B3B4B6"
      />

      <foreignObject x="-5.38125" y="4.9" width="60.6375" height="59.9178">
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{
            backdropFilter: "blur(5.3px)",
            clipPath: "url(#bgblur_0_4060_115541_clip_path)",
            height: "100%",
            width: "100%",
          }}
        />
      </foreignObject>

      <g data-figma-bg-blur-radius="10.6">
        <mask
          id="path-2-outside-1_4060_115541"
          maskUnits="userSpaceOnUse"
          x="4.71875"
          y="15"
          width="40"
          height="40"
          fill="black"
        >
          <rect fill="white" x="4.71875" y="15" width="40" height="40" />
          <path d="M33.2783 16C39.7934 16 44.1562 20.4889 44.1562 27.165V42.5742C44.1562 49.2315 39.7934 53.7178 33.2783 53.7178H16.6152C10.1004 53.7176 5.71875 49.2313 5.71875 42.5742V27.165C5.71875 20.4891 10.1004 16.0002 16.6152 16H33.2783Z" />
        </mask>

        <path
          d="M33.2783 16C39.7934 16 44.1562 20.4889 44.1562 27.165V42.5742C44.1562 49.2315 39.7934 53.7178 33.2783 53.7178H16.6152C10.1004 53.7176 5.71875 49.2313 5.71875 42.5742V27.165C5.71875 20.4891 10.1004 16.0002 16.6152 16H33.2783Z"
          fill="#B3B4B6"
          fillOpacity="0.05"
        />

        <path
          d="M33.2783 16L33.2783 15.5H33.2783V16ZM33.2783 53.7178V54.2178H33.2783L33.2783 53.7178ZM16.6152 53.7178L16.6152 54.2178H16.6152V53.7178ZM16.6152 16V15.5H16.6152L16.6152 16ZM33.2783 16L33.2783 16.5C36.4173 16.5 39.0021 17.5789 40.8022 19.4278C42.6035 21.2779 43.6562 23.9375 43.6562 27.165H44.1562H44.6562C44.6562 23.7165 43.5276 20.7936 41.5187 18.7302C39.5086 16.6656 36.6544 15.5 33.2783 15.5L33.2783 16ZM44.1562 27.165H43.6562V42.5742H44.1562H44.6562V27.165H44.1562ZM44.1562 42.5742H43.6562C43.6562 45.792 42.6037 48.4462 40.8025 50.2934C39.0023 52.1395 36.4174 53.2178 33.2783 53.2178L33.2783 53.7178L33.2783 54.2178C36.6543 54.2178 39.5084 53.0529 41.5184 50.9915C43.5274 48.9313 44.6562 46.0137 44.6562 42.5742H44.1562ZM33.2783 53.7178V53.2178H16.6152V53.7178V54.2178H33.2783V53.7178ZM16.6152 53.7178L16.6153 53.2178C13.4762 53.2177 10.8864 52.1393 9.08148 50.2928C7.2756 48.4454 6.21875 45.7913 6.21875 42.5742H5.71875H5.21875C5.21875 46.0143 6.35272 48.9318 8.36637 50.9918C10.381 53.0528 13.2395 54.2177 16.6152 54.2178L16.6152 53.7178ZM5.71875 42.5742H6.21875V27.165H5.71875H5.21875V42.5742H5.71875ZM5.71875 27.165H6.21875C6.21875 23.9382 7.27584 21.2787 9.08174 19.4284C10.8866 17.5791 13.4763 16.5001 16.6153 16.5L16.6152 16L16.6152 15.5C13.2394 15.5001 10.3807 16.6657 8.3661 18.7299C6.35248 20.793 5.21875 23.716 5.21875 27.165H5.71875ZM16.6152 16V16.5H33.2783V16V15.5H16.6152V16Z"
          fill="url(#paint0_linear_4060_115541)"
          mask="url(#path-2-outside-1_4060_115541)"
        />
      </g>

      <path
        d="M22.6727 32.4104C22.0007 32.4104 21.4065 32.4104 20.8111 32.4104C19.897 32.4104 19.233 32.0199 18.8605 31.1425C18.488 30.265 18.6811 29.4852 19.3176 28.8218C20.5826 27.5032 21.8522 26.1882 23.1389 24.8932C24.0588 23.9675 25.2529 23.964 26.1706 24.8873C27.4584 26.1812 28.7257 27.4985 29.9918 28.8147C30.6238 29.4722 30.8637 30.2521 30.5038 31.133C30.1438 32.014 29.4559 32.3987 28.5497 32.4081C27.9509 32.4151 27.3521 32.4081 26.6745 32.4081C26.6631 32.6809 26.6436 32.9221 26.6436 33.1632C26.6436 35.4104 26.6436 40.8643 26.6436 43.8179C26.6436 44.9121 25.7566 45.7969 24.6623 45.7969C23.5688 45.7969 22.682 44.9122 22.681 43.8187C22.678 40.7189 22.6727 34.8223 22.6727 32.4104Z"
        fill="url(#paint1_linear_4060_115541)"
      />

      <defs>
        <clipPath id="bgblur_0_4060_115541_clip_path" transform="translate(5.38125 -4.9)">
          <path d="M33.2783 16C39.7934 16 44.1562 20.4889 44.1562 27.165V42.5742C44.1562 49.2315 39.7934 53.7178 33.2783 53.7178H16.6152C10.1004 53.7176 5.71875 49.2313 5.71875 42.5742V27.165C5.71875 20.4891 10.1004 16.0002 16.6152 16H33.2783Z" />
        </clipPath>

        <linearGradient
          id="paint0_linear_4060_115541"
          x1="11.8374"
          y1="20.3942"
          x2="40.9095"
          y2="52.2979"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.25" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>

        <linearGradient
          id="paint1_linear_4060_115541"
          x1="40.0036"
          y1="22.8225"
          x2="0.86529"
          y2="55.5572"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#999999" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ImportSettingIcon;
